import { Component, Input, OnInit, EventEmitter, Output, inject, DestroyRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { translate } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { JumpboxService } from 'src/app/services/api/jumpbox.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { ManageColumnsComponent } from '../manage-columns/manage-columns.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import moment from 'moment';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CloudResourcesInventoryComponent } from '../instance-details/cloud-resources-inventory/cloud-resources-inventory.component';
import { TenantService } from 'src/app/services/api/tenant.service';
import { TimeDurationPipe } from 'src/app/pipes/timeDuration.pipe';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { GenericErrorComponent } from '../generic-error/generic-error.component';
import {DataBaseStatus} from 'src/app/models/deploy/database-status'
const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.JUMPBOX_READ_PII,
    action: Permissions.JUMPBOX_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_READ_LIVE,
    action: Permissions.JUMPBOX_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.JUMPBOX_UPDATE_PII,
    action: Permissions.JUMPBOX_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_UPDATE_LIVE,
    action: Permissions.JUMPBOX_UPDATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.JUMPBOX_DELETE_PII,
    action: Permissions.JUMPBOX_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_DELETE_LIVE,
    action: Permissions.JUMPBOX_DELETE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.JUMPBOX_CREATE_PII,
    action: Permissions.JUMPBOX_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.JUMPBOX_CREATE_LIVE,
    action: Permissions.JUMPBOX_CREATE,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.CUSTOMPACKAGE_DELETE,
    action: Permissions.CUSTOMPACKAGE_DELETE,
  },
];

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    providers: [TimeDurationPipe],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class TableComponent  implements OnInit {
  DataBaseStatus = DataBaseStatus;
  @Input() set initialDataSource(data) {
    this.initialData = data;
    this.dataSource = this.initialData;
    this.searchAndSort();
  };
  private destroyRef = inject(DestroyRef);
  @Input() displayColumns;
  @Input() dataLoading;
  @Input() showSkeletonLoader;
  @Input() set searchTerm(data) {
    this.searchText = data;
    this.searchAndSort();
  };
  @Input() dataSourceLength;
  @Input() showTableBorder;
  @Input() page;
  @Input() selectedTenant:string;
  @Output() jumpboxTable = new EventEmitter();
  @Output() approve = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() openSftpForm = new EventEmitter();
  @Output() viewSshKey = new EventEmitter();
  @Output() searchedResults = new EventEmitter();
  @Output() editKey = new EventEmitter();
  @Output() editRouteData = new EventEmitter();
  @Input() pageName;
  @Input() initialCreate = false;
  @Input() routeWithExpiration: any[];
  @Output() viewClickKubernetes = new EventEmitter();
  @Input() sftpEncKeyRotation: boolean;
  @Output() emitData = new EventEmitter();
  @Output() sourceClick = new EventEmitter();
  @Output() custImageTable = new EventEmitter();
  @Input() selectedSolutionId: string;
  @Input() selectedSolutionValue: string;

  tenantId: any;
  columnHeaders: any;
  showPagination = true;
  pageIndex = 0;
  paginationSize = 10;
  pageDataSource: any;
  inprogressStatus = ['inprogress', 'deleting', 'approving', 'deleting', 'rejecting', 'running', 'adding', 'removing', 'updating', 'preparing', 'promoting'];
  failedStatus = ['failed', 'approval_failed', 'rejection_failed','Failed', 'preparation_failed', 'promotion_failed'];
  completedStatus = ['completed', 'approved', 'active', 'added', 'updated','success','Success', 'prepared', 'promoted'];
  rejectedStatus = ['rejected', 'removed']
  expiredStatus = ['expired'];
  deletedStatus = ['deleted'];
  deleteFailedStatus = ['delete_failed', 'deletion_failed'];
  pendingStatus = ['approval_pending'];
  disabledStatus = ['disabled'];
  columns: any;
  allColumns: any;
  searchText: string;
  dataSource: any;
  initialData: any;
  sortDetails: any;
  permissionsMap: { [key: string]: boolean };
  PermissionKeys = PermissionKeys;
  showJumboxMenuProd : boolean;
  showJumboxMenuPii : boolean;
  showJumboxDivider :boolean;
  RouterSegments = RouterSegments;
  expandedElement: any;
  restoreDeleteStatus = [DataBaseStatus.PREPARED, DataBaseStatus.PROMOTED, DataBaseStatus.PROMOTION_FAILED, DataBaseStatus.DELETE_FAILED];

  constructor(private permissionsService: PermissionsService, private activatedRoute: ActivatedRoute, private router: Router, private dialog: MatDialog, private toastrService: CustomToastrService, public jumpboxService: JumpboxService, public sidenavService: SidenavService, private authService: AuthService,  private tenantService: TenantService,private timeDuration: TimeDurationPipe, private solutionsService: SolutionsService,) {

  }

  ngOnInit(): void {
    if(this.pageName == "selectDatabase") this.tenantId = this.selectedTenant;
    else this.tenantId = this.activatedRoute.snapshot.params.id;
    if(this.pageName === "sftpKey") {
      this.tenantService.getTenantDetails(this.tenantId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: any) => {
          if(data?.sharedServices?.pii?.sftpEncKeyRotation && (data?.sharedServices?.pii?.sftpEncKeyRotation === true || data?.sharedServices?.pii?.sftpEncKeyRotation === 'true')) {
            this.sftpEncKeyRotation = true;
          } else {
            this.sftpEncKeyRotation = false;
          }
        });
    }
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
     this.allColumns = this.displayColumns;
        let previousSelection = null;
        if (this.pageName === 'privateEndpoint') {
          previousSelection  = JSON.parse(localStorage.getItem('console-pecols'));
        } else if (this.pageName === 'schedule') {
          previousSelection  = JSON.parse(localStorage.getItem('console-schedulecols'));
        } else if (this.pageName === 'cloudInventory') {
          previousSelection  = JSON.parse(localStorage.getItem('console-cloudcols'));
        } else if (this.pageName === 'sftpKey') {
          previousSelection  = JSON.parse(localStorage.getItem('console-enckeycols'));
        } else if (this.pageName === 'productInventory') {
          previousSelection  = JSON.parse(localStorage.getItem('console-prodcols'));
        } else if (this.pageName === 'customImages') {
          previousSelection  = JSON.parse(localStorage.getItem('console-custImages'));
        } else {
          previousSelection  = JSON.parse(localStorage.getItem('console-jbcols'));
        }
        if (previousSelection) {
          this.allColumns = previousSelection.map((col, i) => ({...this.displayColumns[i], ...col }));
          this.displayColumns = this.allColumns;
        }
        this.displayTableColumns();
      }

      displayTableColumns(): void {

    this.displayColumns.map(item => item.name = item.name);
    this.displayColumns = this.displayColumns.filter(item => item.visible === true || item.key === 'cloudInventorySettings' || item.key === 'jumpBoxSettings' || item.key === 'edgeNetworkSettings'  || item.type === 'scheduleSettings' || item.type === 'settings' || item.key === 'InventoryProductSettings' || item.key === 'CustomImageSettings');    this.calculateRealTime();
    setInterval(() => {
     this.calculateRealTime();
    }, 1000);
    this.columnHeaders = this.displayColumns?.map(item => item?.key);
    this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(this.pageIndex, this.paginationSize));
    this.showJumboxMenuProd =  (this.permissionsMap[PermissionKeys.JUMPBOX_UPDATE_LIVE] || this.permissionsMap[PermissionKeys.JUMPBOX_DELETE_LIVE])
    this.showJumboxMenuPii =  (this.permissionsMap[PermissionKeys.JUMPBOX_UPDATE_PII] || this.permissionsMap[PermissionKeys.JUMPBOX_DELETE_PII]);
    //this.pageDataSource = "";
  }

  calculateRealTime(): void {
    if (this.dataSource?.length > 0 && this.displayColumns?.find(item => item?.type === 'realTime')) {
      const key = this.displayColumns?.find(item => item?.type === 'realTime').key;
      this.dataSource.forEach(item => {
        const expiresAt = item.expiresAt;
        const from = Date.parse(moment(new Date()).utc().format('DD MMM YYYY HH:mm:ss'));
        const to = Date.parse(expiresAt);
        const value = (( to - from ) / 1000 );
        const hours = Math.floor( value / 60 / 60 );
        const remainder = ( value - ( hours * 60 * 60 ) );
        const minutes = Math.floor( remainder / 60 );
        const seconds = Math.floor( remainder - ( minutes * 60 ) );
        if (hours || minutes || seconds) {
          item.realTime = (hours < 10 ? '0' + hours : hours) + ' hrs ' + (minutes < 10 ? '0' + minutes : minutes) + ' min ' +
            (seconds < 10 ? '0' + seconds : seconds) + ' sec';
        } else {
          item.realTime = 0 + ' hrs ' + 0 + ' min ' + 0 + ' sec';
        }
        if (value < 0 || value === 0) {
          item.realTime = 0 + ' hrs ' + 0 + ' min ' + 0 + ' sec';
        }
        if (value < 0 && item.status === 'completed') {
          item.status = 'expired'
        }
      })
    }
  }

  searchAndSort() {
    const searchBy = this.searchText?.trim().toLocaleLowerCase() || '';
    if (this.pageName === 'privateEndpoint') {
      this.dataSource = this.initialData?.filter(item => item.connectionName?.toLocaleLowerCase().includes(searchBy));
    } else if (this.pageName === 'schedule') {
      this.dataSource = this.initialData?.filter(item => item.name?.toLocaleLowerCase().includes(searchBy)|| item.startsOn?.toLocaleLowerCase().includes(searchBy));
    } else if (this.pageName === 'cloudInventory') {
      this.dataSource = this.initialData?.filter(item => item.name?.toLocaleLowerCase().includes(searchBy) || item.type?.toLocaleLowerCase().includes(searchBy));
    } else if (this.pageName === 'scheduleDetails' || this.pageName === 'sftp') {
      this.dataSource = this.initialData;
    } else if(this.pageName === "selectDatabase"){
      this.dataSource = this.initialData?.filter(item => (searchBy && item.name?.toLocaleLowerCase().includes(searchBy)) || !searchBy);
    } else if(this.pageName === 'metricsLog'){
      this.dataSource = this.initialData?.filter(item => item.operation?.toLocaleLowerCase().includes(searchBy));
    } else if(this.pageName === "inventory"){
      this.dataSource = this.initialData?.filter(item => item.name?.toLocaleLowerCase().includes(searchBy) || item.status?.toLocaleLowerCase().includes(searchBy) || item.version?.toLocaleLowerCase().includes(searchBy));
    } else if (this.pageName === 'productInventory') {
      this.dataSource = this.initialData?.filter(item => item.name?.toLocaleLowerCase().includes(searchBy) || item.type?.toLocaleLowerCase().includes(searchBy));
    } else if (this.pageName === 'restoreTable') {
      this.dataSource = this.initialData?.filter(item => item.targetInstanceName?.toLocaleLowerCase().includes(searchBy) || item.sourceInstanceName?.toLocaleLowerCase().includes(searchBy) || item.ticketNumber?.toLocaleLowerCase().includes(searchBy));
    }
    else {
      this.dataSource = this.initialData?.filter(item => item.dataZone?.toLocaleLowerCase().includes(searchBy) || item.name?.toLocaleLowerCase().includes(searchBy));
    }
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.searchedResults.emit(this.dataSource);
    if (this.sortDetails) {
      this.sortData(this.sortDetails);
    }
    this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(this.pageIndex, this.paginationSize));
  }

  sortData(event) {
    this.sortDetails = event;
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.dataSource = this.dataSource?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'name':
        case 'status':
        case 'version':
        case 'createdAt':
        case 'modifiedAt':
        case 'connectionName':
        case 'privateEndpoint':
        case 'description':
        case 'ticketNumber':
        case 'expiresAt':
        case 'startTime':
        case 'endTime':
        case 'frequency':
        case 'cronDefinition':
        case 'startsOn':
        case 'service':
        case 'updatedAt':
        case 'routeName':
        case 'routeId':
        case 'direction':
        case 'encEnabled':
        case 'nextExecutionTime':
        case 'publicKey':
        case 'expirationDate':
        case 'type':
        case 'kind':
        case 'skuData':
        case 'image':
        case 'containerName':
        case 'taskStatus':
        case 'lastExecutionTime':
        case 'fileName':
        case 'pitrTimestamp':
        case 'action':
        case 'finishTime':
        case 'targetInstanceName':
        case 'sourceInstanceName':
        case 'solutionReleaseVersion':
        case 'configurationVersion':
        case 'custImgName':
        case 'isManaged':
        case 'workload':
        case 'operation':
          comparatorResult = a[event.active] && b[event.active] ? a[event.active]?.localeCompare(b[event.active]) : !a[event.active] ? -1 : 1;
          break;
        case 'realTime':
          comparatorResult = a?.realTime && b?.realTime ? a?.realTime?.localeCompare(b?.realTime) : !a?.realTime ? -1 : 1;
          break;
        case 'totalDuration':
          comparatorResult = a?.startTime && b?.startTime && a?.finishTime && b?.finishTime ? this.timeDuration.transform(a.startTime, a.finishTime, "")?.localeCompare(this.timeDuration.transform(b.startTime, b.finishTime, "")) : !this.timeDuration.transform(b.startTime, b.finishTime, "") ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
     this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(this.pageIndex, this.paginationSize));
  }

  public pageChanged(event?): void {
    if (event?.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.paginationSize;
    this.pageDataSource = new MatTableDataSource(this.dataSource?.slice(startIndex, startIndex + this.paginationSize)) || [];
  }

  keyLinkClick(key, keyLink, data): void {
    if (key === 'ticketNumber' && data[keyLink]) {
      const url = `https://itsm-servicedesk.temenos.com/browse/${data[keyLink]}`;
      window.open(url, '_blank');
    } else if ((key === 'connectionName' || key === 'resource') && data[keyLink]) {
      const url = `https://portal.azure.com/#@temenosgroup.onmicrosoft.com/resource${data[keyLink]}`;
      window.open(url, '_blank');
    } else if (data[keyLink]) {
      window.open(data[keyLink], '_blank');
    }
  }

  jumpboxMenuPermission(data){
  this.showJumboxDivider =  (data === 'prod' ? (this.permissionsMap[PermissionKeys.JUMPBOX_UPDATE_LIVE] && this.permissionsMap[PermissionKeys.JUMPBOX_DELETE_LIVE]) : (this.permissionsMap[PermissionKeys.JUMPBOX_UPDATE_PII] && this.permissionsMap[PermissionKeys.JUMPBOX_DELETE_PII]));
  }

  extendJumpbox(jumpboxId){
       this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('JUMPBOX.EXTEND_JUMPBOX'),
            message: translate('JUMPBOX.EXTEND_CONFIRMATION')+'<span class="extend-hours">'+translate('JUMPBOX.EXTEND_HOURS')+ '</span>',
            confirmButtonText: translate('BUTTONS.SUBMIT')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
          if (confirm) {
            const requestObj = {
              tenantId: this.tenantId,
              id: jumpboxId,
              expiry: {
                "unit": "days",
                "value": "1"
              }
            }
            this.jumpboxService.updateJumpboxes(requestObj)
            .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(results => {
                if (results) {
                  this.jumpboxTable.emit();
            setTimeout(() => {
              const title = translate('JUMPBOX.JUMPBOX');
              const message = translate('JUMPBOX.EXTEND_JUMPBOX_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500)
              }
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('ERROR_DIALOG.EXTEND_JUMPBOX_FAILED'),
                  description: errorMessage
                }
              });
          });
        }
      });
  }

  deleteJumpbox(jumpboxId){
    this.dialog.open(ConfirmationDialogComponent, {
       panelClass: 'default-dialog-wrapper',
       width: '566px',
       autoFocus: false,
       data: {
         title: translate('JUMPBOX.DELETE_JUMPBOX'),
         message: translate('JUMPBOX.DELETE_CONFIRMATION'),
         confirmButtonText: translate('BUTTONS.CONFIRM')
       }
     })
       .afterClosed()
       .pipe(takeUntilDestroyed(this.destroyRef))
       .subscribe(confirm => {
       if (confirm) {
         this.jumpboxService.deleteJumpboxes(this.tenantId, jumpboxId)
         .pipe(takeUntilDestroyed(this.destroyRef))
           .subscribe(results => {
             if (results) {
              this.jumpboxTable.emit();
            setTimeout(() => {
              const title = translate('JUMPBOX.JUMPBOX');
              const message = translate('JUMPBOX.DELETE_JUMPBOX_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
             }
         },
         (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('JUMPBOX.JUMPBOX_DELETION_FAILED'),
                  description: errorMessage
                }
              });
         });
       }
     });
 }
 //deleted the selected custom Image
 deleteCustomImage(packRefId,solutionId){
  if (this.permissionsMap[PermissionKeys.CUSTOMPACKAGE_DELETE]) {
    this.dialog.open(ConfirmationDialogComponent, {
       panelClass: 'default-dialog-wrapper',
       width: '566px',
       autoFocus: false,
       data: {
         title: translate('CUSTOM_IMAGES.DELETE_CUST_IMG'),
         message: translate('CUSTOM_IMAGES.DELETE_CONFIRMATION'),
         confirmButtonText: translate('BUTTONS.CONFIRM')
       }
     })
       .afterClosed()
       .pipe(takeUntilDestroyed(this.destroyRef))
       .subscribe(confirm => {
       if (confirm) {
         this.solutionsService.deleteReferencePackages(solutionId, packRefId)
         .pipe(takeUntilDestroyed(this.destroyRef))
           .subscribe(results => {
             if (results) {
              this.custImageTable.emit();
            setTimeout(() => {
              const title = translate('CUSTOM_IMAGES.CUSTOM_IMAGE');
              const message = translate('CUSTOM_IMAGES.DELETE_CUST_IMG_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
             }
         },
         (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                minHeight: '280px',
                width: '630px',
                panelClass: 'flex-dialog',
                data: {
                  title:  translate('CUSTOM_IMAGES.CUST_IMG_DELETION_FAILED'),
                  description: errorMessage
                }
              });
         });
       }
     });
    } else {
        this.dialog.open(GenericErrorComponent, {
        minHeight: '300px',
        width: '566px',
        panelClass: 'flex-dialog'
      });
    }
 }

  columnSettings(): void {
      this.dialog.open(ManageColumnsComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '754px',
      autoFocus: false,
      data: {
        title: translate('MANAGE_COLUMNS.TITLE'),
        subTitle: translate('MANAGE_COLUMNS.SUBTITLE'),
        columns: this.allColumns,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      if (result) {
        this.allColumns = result;
        this.displayColumns = result;
        if (this.pageName === 'privateEndpoint') {
          this.displayTableColumns();
          localStorage.setItem('console-pecols', JSON.stringify(result));
        } else if (this.pageName === 'schedule') {
          this.displayTableColumns();
          localStorage.setItem('console-schedulecols', JSON.stringify(result));
        } else if (this.pageName === 'cloudInventory') {
          this.displayTableColumns();
          localStorage.setItem('console-cloudcols', JSON.stringify(result));
        } else if (this.pageName === 'sftpKey') {
          this.displayTableColumns();
          localStorage.setItem('console-enckeycols', JSON.stringify(result));
        } else if (this.pageName === 'productInventory') {
          this.displayTableColumns();
          localStorage.setItem('console-prodcols', JSON.stringify(result));
        } else if (this.pageName === 'customImages') {
          this.displayTableColumns();
          localStorage.setItem('console-custImages', JSON.stringify(result));
        } else {
          this.displayTableColumns();
          localStorage.setItem('console-jbcols', JSON.stringify(result));
        }
      } else {
        let previousSelection = null;
        if (this.pageName === 'privateEndpoint') {
          previousSelection = JSON.parse(localStorage.getItem('console-pecols'));
        } else if (this.pageName === 'schedule') {
          previousSelection = JSON.parse(localStorage.getItem('console-schedulecols'));
        } else if (this.pageName === 'cloudInventory') {
          previousSelection = JSON.parse(localStorage.getItem('console-cloudcols'));
        } else if (this.pageName === 'sftpKey') {
          previousSelection = JSON.parse(localStorage.getItem('console-enckeycols'));
        } else if (this.pageName === 'productInventory') {
          previousSelection = JSON.parse(localStorage.getItem('console-prodcols'));
        } else if (this.pageName === 'customImages') {
          previousSelection = JSON.parse(localStorage.getItem('console-custImages'));
        } else {
          previousSelection = JSON.parse(localStorage.getItem('console-jbcols'));
        }
        if (previousSelection) {
          this.allColumns = previousSelection;
          this.displayColumns = previousSelection;
        }
      }
    })
  }

  radioClick(data): void {
      this.initialData.map(item => item.selected = false);
      if (this.pageName === 'selectDatabase') {
        this.initialData.find(item => item.id === data.id).selected = !this.initialData.find(item => item.id === data.id).selected;
      } else {
        this.initialData.find(item => item.id === data.id).selected = !this.initialData.find(item => item.id === data.id).selected;
      }
      this.approve.emit(data);
    }

  viewErrors(data): void {
    if (data?.errors?.length > 0) {
      if (this.pageName === 'restoreTable' && data.status === DataBaseStatus.PREPARATION_FAILED) {
        const title = data.status === DataBaseStatus.PREPARATION_FAILED ? translate('NOTIFICATIONS.SETTING_UP_FAILED') : "";
        const message = translate('NOTIFICATIONS.SETTING_UP');
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '280px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title: title,
            description:  message,
            restoreError: true
          }
        });
        return;
      }
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: this.page === 'jumpbox' && data.status === 'deletion_failed' ? translate('NOTIFICATIONS.JUMPBOX_DELETION_FAILED') :
          this.page === 'privateConnection' && (data.status === 'delete_failed' || data.status === 'deletion_failed') ? translate('EDGE_NETWORK_DETAILS.DELETION_FAILED') :
          this.page === 'privateConnection' && data.status === 'approval_failed' ? translate('EDGE_NETWORK_DETAILS.APPROVAL_FAILED') :
          this.page === 'privateConnection' && data.status === 'rejection_failed' ? translate('EDGE_NETWORK_DETAILS.REJECTION_FAILED') :
          this.page === 'jumpbox' && data.status === 'failed' ? translate('NOTIFICATIONS.JUMPBOX_CREATION_FAILED') :
          this.pageName === 'restoreTable' && (data.status === DataBaseStatus.DELETE_FAILED) ? translate('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE_FAILED'):
          this.pageName === 'restoreTable' && (data.status === DataBaseStatus.RESTORE_FAILED) ? translate('NOTIFICATIONS.RESTORE_FAILED') : translate('NOTIFICATIONS.DEPLOYMENT_FAILED'),
          descriptionError: data?.errors,
          subtitle: this.page === 'privateConnection' ? data?.connectionName : data?.name
        }
      });
    }
  }

  promoteClick(data,action): void {
    data.action = action;
    this.emitData.emit(data);
  }

  navigationClick(data): void {
    if (this.pageName === 'restoreTable') {
      this.sourceClick.emit(data);
    } else if(this.pageName === 'schedule')  {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.SCHEDULE, data.id]);
    } else {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CUSTOM_IMAGE, data.id], {
        queryParams: {
        solutionId: this.selectedSolutionId,
        solutionName: this.selectedSolutionValue
        }
      });
    }
  }

  checkZeroTimeZone(time): boolean {
    return time?.split('')?.pop() === 'Z' ? true : false;
  }

  onExpandArrowClick(event: MouseEvent, data): void {
    event.stopPropagation();
    const matchedRoute = this.routeWithExpiration.find(item => item.routeId === data.routeId);
    const combinedData = {
    ...data,
    ...(matchedRoute || {})
  };
    this.expandedElement = this.expandedElement?.routeId === data.routeId ? null : combinedData;
    this.initialData.find(item => item.routeId === data.routeId).arrowClick = !this.initialData.find(item => item.routeId === data.routeId).arrowClick;
    this.initialData.forEach(item =>  {
      if(item.routeId !== data.routeId) {
        item.arrowClick = false;
      }
    });
  }

  openMenu(): void {
    this.expandedElement = null;
    this.dataSource?.forEach(data => data.arrowClick = false);
    setTimeout(() => {
      if (document.getElementsByClassName("cdk-overlay-container")) {
        const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
        if (element) {
          element.style.display = 'block';
        }
      }
    }, 100);
  }

  deleteRoute(data): void {
    this.delete.emit(data);
  }

  /**
   * This method calls emit when user tries to edit the enc keys.
   * @param value would be the selected key data.
   */
  editKeyRoute(data): void {
    this.editKey.emit(data);
  }

  editRoute(data): void {
    this.editRouteData.emit(data);
  }

  openSshKeyForm(data): void {
    this.openSftpForm.emit(data);
  }

  viewSshKeys(expandedElement): void {
    this.viewSshKey.emit(expandedElement);
  }

  onCopy(field): void {
    this.toastrService.clear();
    this.toastrService.checkboxMessage(field + ' Copied')
  }

   /**
   * This method calls when a user needs to copy the cloud resource in json format.
   */
  copyInventoryDetails(data){
    const dataInventory = {
      inventoryData: data,
      copyInventoryData: true
    };
     this.sidenavService.openInRightSidenav(CloudResourcesInventoryComponent, dataInventory);
  }

  getExpiryStatus(date?:string){
    return  new Date(date) < new Date()
  }

  viewKubernetes(data): void {
    this.viewClickKubernetes.emit(data);
  }

  /* Show the Retry button based on status */
  showRetry(data: any): boolean {
    if (data?.status === DataBaseStatus.PROMOTION_FAILED) return true;
  }

  /* Triggers retry restore action by emitting event to parent component */
  retryRestore(data,action): void {
    data.action = action;
    this.emitData.emit(data);
  }
}
